import React, { useState, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardTransition,
  zIndexLayers,
} from '../styles';
import { Button, Link } from './ui';
import { slugify } from '../utils';

const StyledCookieNotice = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 30px 40px;
  width: 100%;
  background-color: ${brandColours.septenary};
  z-index: ${zIndexLayers.fifth};

  ${minBreakpointQuery.smedium`
    padding:45px;
    left: 50px;
    bottom: 100px;
    border-radius: 10px;
    max-width: 500px;
  `}
`;

const StyledInner = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 15px;

  ${minBreakpointQuery.smedium`
    gap: 20px;
  `}
`;

const StyledHeading = styled.h3`
  ${fontSize(20)};
  font-weight: ${fontWeights.regular};

  ${minBreakpointQuery.small`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(24)};
  `}
`;

const StyledText = styled.p`
  line-height: 1.6;
`;

const StyledLink = styled(Link)`
  text-decoration: underline;
  transition: ${standardTransition('color')};
  text-underline-offset: 2px;
  margin-left: 3px;

  &:hover {
    color: ${brandColours.primary};
  }
`;

const StyledButton = styled(Button)`
  width: 200px;
`;

const CookieNotice = () => {
  const {
    datoCmsSite: { name },
    datoCmsCookieNotice: { text, link },
  } = useStaticQuery(graphql`
    query CookieNoticeQuery {
      datoCmsSite {
        name
      }
      datoCmsCookieNotice {
        text
        link {
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
    }
  `);

  const localStorageKey = `${slugify(name)}:accept-cookie-notice`;
  const [acceptedCookie, setAcceptedCookie] = useState();

  useEffect(() => {
    setAcceptedCookie(localStorage.getItem(localStorageKey) || false);
  }, [localStorageKey]);

  const acceptCookieNotice = () => {
    setAcceptedCookie(true);
    localStorage.setItem(localStorageKey, true);
  };

  return acceptedCookie === false ? (
    <StyledCookieNotice>
      <StyledInner>
        <StyledHeading>Cookie Policy</StyledHeading>
        <StyledText>
          {text}
          <StyledLink to={link.pageUrl}>{link.text}</StyledLink>
        </StyledText>
        <StyledButton onClick={() => acceptCookieNotice()}>Accept</StyledButton>
      </StyledInner>
    </StyledCookieNotice>
  ) : (
    ''
  );
};

export default CookieNotice;
